var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCodeCircle01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0002 0.833374C4.93755 0.833374 0.833496 4.93743 0.833496 10C0.833496 15.0626 4.93755 19.1667 10.0002 19.1667C15.0628 19.1667 19.1668 15.0626 19.1668 10C19.1668 4.93743 15.0628 0.833374 10.0002 0.833374ZM8.50608 8.0893C8.83152 7.76386 8.83152 7.23622 8.50608 6.91078C8.18065 6.58535 7.65301 6.58535 7.32757 6.91078L4.82757 9.41078C4.50214 9.73622 4.50214 10.2639 4.82757 10.5893L7.32757 13.0893C7.65301 13.4147 8.18065 13.4147 8.50608 13.0893C8.83152 12.7639 8.83152 12.2362 8.50608 11.9108L6.59534 10L8.50608 8.0893ZM12.6728 6.91078C12.3473 6.58535 11.8197 6.58535 11.4942 6.91078C11.1688 7.23622 11.1688 7.76386 11.4942 8.0893L13.405 10L11.4942 11.9108C11.1688 12.2362 11.1688 12.7639 11.4942 13.0893C11.8197 13.4147 12.3473 13.4147 12.6728 13.0893L15.1728 10.5893C15.4982 10.2639 15.4982 9.73622 15.1728 9.41078L12.6728 6.91078Z",
    fill: "#4BAB71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeCircle01);
export default __webpack_public_path__ + "static/media/code-circle-01.50fff938637b7005bdc6d6895243233d.svg";
export { ForwardRef as ReactComponent };